import * as React from 'react';

import { ThumbsUpFilledIcon, ThumbsUpIcon } from '@coursera/cds-icons';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  selected?: boolean;
  onSelect(): void;
  onDeselect(): void;
};

const FeedbackLike = ({ selected, onSelect, onDeselect }: Props) => {
  const cancelLikeLabel = _t('Cancel Coursera AI Chat message like');
  const likeLabel = _t('Like Coursera AI Chat message');

  return (
    <div>
      {selected ? (
        <CoachIconButton
          size="small"
          aria-label={cancelLikeLabel}
          tooltip={_t('Cancel like')}
          onClick={onDeselect}
          icon={<ThumbsUpFilledIcon color="default" size="small" />}
        />
      ) : (
        <CoachIconButton
          size="small"
          aria-label={likeLabel}
          tooltip={_t('Like')}
          onClick={onSelect}
          icon={<ThumbsUpIcon color="default" size="small" />}
        />
      )}
    </div>
  );
};

export default FeedbackLike;
